import React from "react";

// css
import "./PreFooter.css";

const PreFooter = () => {
  return (
    <section className="pre-footer">
      <div className="pre-footer-main">
        <div className="main-margin prefooter-content">
          <h1 className="text-2xl mt-10 uppercase">Summary Risk Factors</h1>
          <h3 className="my-2 leading-normal text-justify mb-9 font-semibold">
            DIR is a public non-listed real estate investment trust (“REIT”),
            that offers limited liquidity when compared to other investment
            vehicles, such as publicly listed REITs. Investors in DIR are not
            receiving publicly listed shares. An investment in DIR involves a
            high degree of risk, including the same risks associated with an
            investment in real estate investments, including fluctuations in
            property values, higher expenses or lower expected income, and
            potential environmental liabilities. You should purchase shares only
            if you can afford a complete loss of your investment. We are an
            “emerging growth company” under the federal securities laws and will
            be subject to reduced public company reporting requirements.
            StratCap Securities, LLC, member FINRA and SIPC, is the affiliated
            dealer manager for the DIR offering. See the “Risk Factors” section
            of the prospectus for more details. These risks include, among
            others:
          </h3>
          {/* Bullets from here down */}
          <ul className="cust-ul list-disc">
            <li className="text-base">
              There is no public trading market for our common stock and
              repurchase of shares by us will likely be the only way to dispose
              of your shares. Our share repurchase program will provide you with
              the opportunity to request that we repurchase your shares on a
              monthly basis, but we are not obligated to repurchase any shares
              and may choose to repurchase only some, or even none, of the
              shares that have been requested to be repurchased. In addition,
              repurchases will be subject to available liquidity and other
              significant restrictions. Further, our board of directors may make
              exceptions to, modify, or suspend or terminate our share
              repurchase program. As a result, our shares should be considered
              as having only limited liquidity and at times may be illiquid.
            </li>
            <li className="text-base">
              We cannot guarantee that we will continue to make distributions,
              and the amount of distributions we may make is uncertain and we
              have funded and may in the future fund such distributions from
              sources other than cash flow from operations, including, without
              limitation, from borrowings or the sale of or repayment under our
              assets, and we have no limits on the amounts we may pay from such
              sources. The use of these sources for distributions may decrease
              the amount of cash we have available for new investments, share
              repurchases and other corporate purposes, and could reduce your
              overall return.
            </li>
            <li className="text-base">
              This is a “blind pool” offering; you will not have the opportunity
              to evaluate all of the investments we will make before we make
              them.
            </li>
            <li className="text-base">
              This is a “best efforts” offering and if we are unable to raise
              substantial funds, then we will be more limited in our
              investments.
            </li>
            <li className="text-base">
              We may change our investment policies without stockholder notice
              or consent, which could result in investments that are different
              from those described in this prospectus.
            </li>
            <li className="text-base">
              The purchase and repurchase price for shares of our common stock
              are generally based on our prior month’s NAV (subject to material
              changes as described above) and are not based on any public
              trading market. While there will be independent annual appraisals
              of our properties, the appraisal of properties is inherently
              subjective, and our NAV may not accurately reflect the actual
              price at which our properties could be liquidated on any given
              day.
            </li>
            <li className="text-base">
              We are dependent on our advisor to conduct our operations. Our
              advisor will face conflicts of interest as a result of, among
              other things, the allocation of investment opportunities among us
              and other investment vehicles, the allocation of time of its
              investment professionals and the substantial fees that we will pay
              to our advisor.
            </li>
            <li className="text-base">
              There are limits on the ownership and transferability of our
              stock. See “Description of Capital Stock — Restrictions on
              Ownership and Transfer” in the prospectus.
            </li>
            <li className="text-base">
              If we fail to continue to qualify as a REIT and no relief
              provisions apply, our NAV and cash available for distribution to
              our stockholders could materially decrease.
            </li>
            <li className="text-base">
              While our investment strategy is to invest in digital
              infrastructure real estate assets, preferably with long-term
              leases or contracts, to creditworthy tenants or customers to
              deliver tax-efficient income to our investors via regular daily
              distributions, payable monthly, an investment in us is not an
              investment in fixed income. Fixed income has material differences
              from an investment in us, including those related to vehicle
              structure, investment objectives and restrictions, risks,
              fluctuation of principal, safety, guarantees or insurance, fees
              and expenses, liquidity and tax treatment.
            </li>
            <li className="text-base">
              The acquisition of investment properties may be financed in
              substantial part by borrowing, which increases our exposure to
              loss. The use of leverage involves a high degree of financial risk
              and will increase the exposure of the investments to adverse
              economic factors.
            </li>
            <li className="text-base">
              Investing in digital infrastructure real estate assets involves
              certain risks, including but not limited to: tenants, customers
              and subscribers declaring bankruptcy; an inability to secure funds
              for future capital improvements or capital needs; new technologies
              and changes in a tenant’s business model; tenants consolidating
              their operations, exiting the telecommunications business or
              sharing digital infrastructure real estate; and decreases in
              demand for data (which in turn decreases demand for digital
              infrastructure real estate).
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PreFooter;
